import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/views');
export const create = (data) => req('POST', `/`, {
    body: data,
});
export const favorite = (id) => req('POST', `/${id}/favorite`, {});
export const unfavorite = (id) => req('POST', `/${id}/unfavorite`, {});
export const updateById = (id, data) => req('PATCH', `/${id}`, {
    body: data,
});
export const deleteById = (id) => req('DELETE', `/${id}`, {});
//# sourceMappingURL=views.js.map